import {
    useCallback,
    useState,
    useRef,
    useEffect
} from 'react'
import { useNavigate } from 'react-router-dom'
import ProfileDropdown from './Components/ProfileDropDown'
import { signOut } from 'aws-amplify/auth'
import fetchAuthUser from './common-services/fetch-auth-user'
import getCompanyName from './Pages/Home/services/company-info'

const ENV_TO_COMPANY = {
    QA: "QA Portal",
    ADMIN: "Admin Portal",
    EXECUTIVE: "Executive Portal"
}

export default function Header() {
    const [menuOpen, setMenuOpen] = useState(false)
    const menuRef = useRef(null)
    const [companyName, setCompanyName] = useState('')
    const [user, setUser] = useState(null)

    const navigate = useNavigate()

    useEffect(() => {
        const fetchRoleAndCompany = async () => {
            try {
                const envKey = process.env.REACT_APP_SELECTED_ENV;

                if (envKey === "HR") {
                    const name = await getCompanyName();
                    setCompanyName(name);
                } else if (envKey && ENV_TO_COMPANY[envKey]) {
                    setCompanyName(ENV_TO_COMPANY[envKey]);
                }
            } catch (err) {
                console.error("Failed to load company name:", err);
            }
        }

        fetchRoleAndCompany()
    }, [])

    const handleSignOut = useCallback(async () => {
        try {
            await signOut()
            window.location.reload()
        } catch (error) {
            console.log("Error signing out: ", error)
        }
    }, [])

    const handleNavigate = useCallback(() => {
        navigate("/")
    }, [navigate])

    // Close dropdown when clicking outside
    useEffect(() => {
        function handleClickOutside(e) {
            if (menuRef.current && !menuRef.current.contains(e.target)) {
                setMenuOpen(false)
            }
        }
        document.addEventListener("mousedown", handleClickOutside)
        return () => document.removeEventListener("mousedown", handleClickOutside)
    }, [])

    return (
        <header className="w-full h-16 bg-white shadow flex items-center justify-between px-8">
            {/* Left: Logo */}
            <div
                className="flex-shrink-0 cursor-pointer"
                onClick={handleNavigate}
                role="button"
                aria-label="Go to homepage"
            >
                <img
                    src="/logo.png"
                    alt="VerifiedID Logo"
                    className="w-40 h-auto hover:opacity-80 transition-opacity duration-200"
                />
            </div>

            {/* Center: Company Name */}
            <div className="text-center mr-[15%] md:mr-[6%] lg:mr-[5%]">
                {companyName && (
                    <span
                        className="text-base sm:text-lg md:text-xl lg:text-2xl font-bold text-gray-700 px-3 py-1 rounded-xl"
                        title={companyName.replace(/\./g, "")}
                    >

                        <span className="block md:hidden">
                            {companyName.replace(/\./g, "").length > 20
                                ? companyName.replace(/\./g, "").slice(0, 20) + "…"
                                : companyName.replace(/\./g, "")}
                        </span>

                        <span className="hidden md:block">
                            {companyName.replace(/\./g, "")}
                        </span>
                    </span>
                )}
            </div>


            <div className="relative" ref={menuRef}>

                <ProfileDropdown />
            </div>
        </header>
    )
}
